
<footer class="ds-ft-footer">
    <p class="ds-ft-webspecify">Best viewed on the latest versions of Microsoft Edge, Chrome or Safari.</p>
    <!-- <img [src]="footerLogo" alt="Footer Logo"> -->
  </footer>